import { HttpClient } from '@angular/common/http';
import { Injectable, SecurityContext } from '@angular/core';
import { Observable } from 'rxjs';
import { OperationResult } from '../models/server-result/operation-result';
import { AppContextService } from '../services/app-context.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuditEntry } from '../models/audit-entries/audit-entry';
import { AuditEntriesSearchCriteria } from '../models/audit-entries/audit-entries-search-criteria';

@Injectable()
export class AuditApiService {
	constructor(
		private http: HttpClient,
		private appContext: AppContextService,
		private domSanitizer: DomSanitizer
	) {}

	public searchAuditEntries(inputDto: AuditEntriesSearchCriteria): Observable<OperationResult<AuditEntry[]>> {
		return this.http.post<OperationResult<AuditEntry[]>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAuditAPIUrl() + '/audit/search')!,
			inputDto
		);
	}

	public countSearchAuditEntries(inputDto: AuditEntriesSearchCriteria): Observable<OperationResult<number>> {
		return this.http.post<OperationResult<number>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAuditAPIUrl() + '/audit/count')!,
			inputDto
		);
	}

	public getAuditEntryById(auditEntryId: string): Observable<OperationResult<AuditEntry>> {
		return this.http.get<OperationResult<AuditEntry>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAuditAPIUrl() + '/audit/' + auditEntryId)!
		);
	}
}
